<template>
  <div class="group-reports">
    <div class="export-report">
      <class-time-tracking-exporter :report-data="studentActivity" :startDate="startDate" :canExport="canExport" :endDate="endDate" />
    </div>
    <date-interval-picker
      class="date-interval-sec"
      :scope="scope"
      :showScope="false"
      :endDate="endDate"
      :startDate="startDate"
      :timelineLabel="timelineLabel"
      @updatedDate="updatedDate"
      @updateScope="updateScope"
    />
    <h3 id="reports-table-header"> {{ $t("classes.reports") }}</h3>
    <div class="table-wrapper">
      <el-table
        :data="studentActivity"
        style="width: 100%"
        :empty-text="$t('common.no_values')"
      >
        <user-info-table-column
          prop="name"
          fixed
          :label="$t($i18nLabelsHelper(organizationType, 'student_name'))"
          width="300"
        />
        <el-table-column
          v-for="(date, idx) in getTimeline"
          :key="idx"
          :label="date"
          min-width="100"
          class-name="activity-cell"
        >
          <template slot-scope="scope">
            {{getActivity(idx, scope)}}
          </template>
        </el-table-column>
      </el-table>
      <!-- <div class="pagination">
        <pagination
          :page-size="maxNumberOfElements"
          :total="totalPage"
          :pager-counter="5"
          :current-page.sync="currentPage"
          v-on:current-change="updateCurrentPage"
        />
        <over-table-pagination
          class="over-table-pagination-right"
          :total="totalPage"
          :currentPage="currentPage"
          :pageSize="maxNumberOfElements"
        />
      </div> -->
    </div>
  </div>
</template>

<script>
  import { createNamespacedHelpers, mapState } from 'vuex'
  import { pathOr, path } from 'ramda'
  import { format, toDate, startOfMonth } from 'date-fns'
  import { NUMBER_ELEMENTS_PER_PAGE } from "@/constants/generic"
  import DateIntervalPicker from '@/components/common/DateIntervalPicker'
  import UserInfoTableColumn from '@/components/classes/UserInfoTableColumn'
  import Pagination from '@/components/common/Pagination'
  import OverTablePagination from '@/components/common/OverTablePagination'
  import { warningMessage } from '../../../utils/messages'
  import { monthlyDateInterval, weeklyDateInterval, dailyDateInterval } from '@/utils/dateInterval'
  const { mapGetters, mapActions } = createNamespacedHelpers('classes')
  import showNoReportDataWarning from '@/components/common/mixins/noReportData'
  import { isSessionExpireError } from '@/utils/sessionExpireErr'
  import ClassTimeTrackingExporter from "@/components/common/ClassTimeTrackingExporter"

  export default {
    mixins: [showNoReportDataWarning],
    components: {
      UserInfoTableColumn,
      // Pagination,
      // OverTablePagination,
      DateIntervalPicker,
      ClassTimeTrackingExporter
    },
    data() {
      return {
        currentPage: 1,
      }
    },
    props: ['organizationType', 'startDate', 'endDate', 'scope', 'timelineLabel', 'groupId'],
    computed: {
      ...mapGetters(['getCurrentClass']),
      ...mapState('classes', [
        'studentActivity'
      ]),
      ...mapGetters({
        userIsTeacher: "organization/isOrganizationTeacher",
        userIsAdmin: "organization/isOrganizationAdmin",
        userIsAssociateAdmin: "organization/isOrganizationAssociateAdmin",
      }),
      getTimeline() {
        if( this.scope === "monthly" ) {
          return monthlyDateInterval(this.startDate, this.endDate)
        } else if ( this.scope === 'weekly' ) {
          return weeklyDateInterval(this.startDate, this.endDate)
        }

        return dailyDateInterval(this.startDate, this.endDate)
      },
      maxNumberOfElements() {
        return NUMBER_ELEMENTS_PER_PAGE
      },
      totalPage() {
        return pathOr(0, ['students','count'])(this.getCurrentClass)
      },
      canExport() {
        return true
      },
      startDateAndendDateAndscope(){
        return `${this.startDate}|${this.endDate}${this.scope}`;
      }
    },
    methods: {
      getActivity(idx, scope) {
        const rowActivity =  pathOr(0, ['row', 'data', idx])(scope)
        return rowActivity;
      },
      ...mapActions(['getCurrentClassUsers', 'getStudentActivity']),
      formatDate(date) {
        return format(new Date(date), 'dd MMM yyyy')
      },
      updateCurrentPage(page) {
        this.currentPage = page;
        this.getClasses({ page, ...this.filterParams })
      },
      updatedDate(dateObject) {
        return this.$emit('updatedDate', dateObject)
      },
      updateScope(newScope) {
        return this.$emit('updateScope', newScope)
      },
      fetchStudentActivity(options){
        return this.getStudentActivity(options)
          .catch((err) => {
            if(!isSessionExpireError(err))
              this.showNoReportDataWarning()
          })
      }
    },
    async mounted () {
      try {
        // const groupId = path(['getCurrentClass', 'id'])(this)
        await this.fetchStudentActivity({ groupId: this.groupId, from: this.startDate, to: this.endDate, scope: this.scope })
      } catch(error) {
        return warningMessage(this.$t('common.generic_error_message'))
      }
    },
    watch: {
      startDateAndendDateAndscope: {
        handler(newValue, oldValue) {
          if(newValue !== oldValue) {
            // const groupId = path(['getCurrentClass', 'id'])(this)
            return this.fetchStudentActivity({ groupId: this.groupId, from: this.startDate, to: this.endDate, scope: this.scope })
          }
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .group-reports {
    margin-top: 38px;
    .export-report {
      display: inline-block;
      float: right;
    }
    .date-interval-sec {
      display: inline-block;
      float: right;
      margin: 0 20px;
    }
  }
  .table-wrapper {
    margin-top: 30px;
    padding: 32px;
  }

  ::v-deep .user-info {
    padding-left: 10px;
  }

  ::v-deep .activity-cell {
    padding: 0;
    height: 100%;

    .cell {
      height: 100%;
      padding-right: 0;
      display: flex;
      justify-content: center;

      i.activity-icon:before {
        height: 50px;
        width: 50px;
        background-size: cover;
        padding-right: 0px;
      }
    }
  }

  #reports-table-header{
    padding-right: 32px;
    padding-left: 32px;
  }
</style>
